// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
  display: none;
}

.view-seller-campaigns {
  height: 90vh;
}
.scroll-container {
  max-height: 72vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.view-campaign-container {
  height: 100%;
}
/* .seller-campaign-list {
  height: 90px;
} */
.view-campaigns-header {
  height: 90px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.bread-crumb-placement {
  padding-top: 13px;
}
.view-campaigns-header .search-input {
  margin-left: 1.5rem;
}
.ant-image .arrow-align {
  margin-right: 16px;
  width: 20px;
}

.popover-label {
  font-family: Roboto !important;
  font-size: 14px;
  font-weight: 500;
}

.view-campaign-search .ant-input-prefix {
  margin-right: 1rem;
}

.view-campaign-search {
  font-family: Roboto !important;
  height: 50px;

  .ant-input-group {
    height: 100%;
  }

  .ant-input {
    font-family: Roboto !important;
    height: 100%;
  }

  .ant-input-outlined:hover {
    border: 1px solid #d9d9d9;
  }

  .ant-input-outlined:focus-within {
    border: 1px solid #d9d9d9;
  }

  .ant-input-search-button {
    height: 100%;
    border-left: none !important;
  }

  .ant-input-search-button:not(.ant-btn-primary):active {
    color: #d9d9d9 !important;
  }

  .ant-input-search-button:hover {
    border-top: 1px solid #d9d9d9 !important;
    border-right: 1px solid #d9d9d9 !important;
    border-bottom: 1px solid #d9d9d9 !important;
    border-left: none !important;
    color: #d9d9d9 !important;
  }
}

.view-campaign-search-btn {
  margin-left: 15.5px;
}

.seller-campaign-card-container .campaign-details {
  font-family: "Roboto";
}

.seller-campaign-card-container .campaign-header {
  font-weight: 500;
  font-size: 16px;
}

.view-campaign-segments {
  margin-top: 22px;
  vertical-align: middle;

  .ant-segmented-group {
    align-items: center;
  }

  .ant-segmented-item {
    margin-right: 21px;

    .selectedCount {
      border-radius: 3px;
      background: #fff;
      padding: 3px 8px;
    }
  }

  .ant-segmented-item,
  .ant-segmented-item-selected {
    .ant-segmented-item-label,
    .ant-segmented-item-label:hover {
      padding: 8px 20px;
    }

    .selectedCount {
      border-radius: 3px;
      background: #f5f5f5;
      padding: 3px 8px;
    }
  }
}

.ellipsis-btn {
  height: 40px;
  width: 40px;
  border: none;
}

.ellipsis-btn:hover,
.ellipsis-btn:active,
.ellipsis-btn:focus {
  background: #f0f0f0 !important;
}

.popover-content {
  width: 212px;
  height: 112px;
}

.popover-campaign {
  display: flex;
  padding: 12px 8px 12px 14px;
  width: 11vw;
  margin-left: 0.5rem;
  height: 43px;
  border: none;
  justify-content: center;
}

.popover-campaign:hover,
.popover-campaign.active {
  background: #d2042d !important;
  color: #fff !important;
  border-radius: 10px;
}

.popover-campaign:hover .share-icon {
  filter: brightness(0) invert(1);
}

.action-column {
  display: flex;
  align-items: center;

  .view-details {
    margin-right: 38px;
    margin-left: 8px;
    margin-bottom: 0;
    cursor: pointer;
  }
}

.view-campaign-ellipsis {
  transform: rotate(90deg);
  height: 40px;
}

.empty-campaigns {
  display: flex;
  justify-content: center;
}
.view-campaigns-table {
  width: 94vw;
  margin-top: 18px;
  .ant-table-cell {
    font-family: Roboto;
    padding: 12px 16px !important;
  }

  .ant-pagination-options {
    display: none;
  }
}

.payment-term-form {
  margin: 0.5rem;
}

.view-campaigns-table .ant-table-thead > tr > th {
  text-align: left !important;
}

.custom-row {
  height: 70px !important;
}

.share-campaign {
  width: 100%;
  margin-top: 1rem;
  background: #d2042d;
  color: #fff;
  padding: 12px;
}

.rfp-badge-css {
  font-family: Roboto;
  /* background: #d2042d; */
  color: #fff;
}

.rfp-badge-css sup {
  background: #d2042d !important;
}
.set-width {
  width: max-content;
}
/* Tablet  */

@media (max-width: 1025px) {
  .view-campaign-segments {
    width: 90vw !important;
    overflow-x: scroll;
  }
  .view-campaign-table-container {
    overflow-x: auto;
    margin-top: 1rem;
  }
  .view-campaigns-header .search-input {
    margin-left: 0;
  }
  .view-campaigns-table {
    background: "#fff";
  }
  .view-campaigns-table .ant-table-tbody {
    font-family: Roboto;
    background: #fff;
  }
}
/* Mobile  */
@media (max-width: 768px) {
  .campaign-detail-container-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
  }
  .bread-crumb-placement {
    display: none;
  }
  .mobile-view-segmentss-tab {
    max-width: 500px;
    min-width: 300px;
    width: auto;
    overflow: auto;
  }
  .view-campaigns-header {
    margin-top: 10px;
    height: 151px;
    align-items: center;
  }
  .scroll-container {
    padding-right: 0;
  }
  .seller-campaign-card-container {
    gap: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .seller-campaign-cards .ant-card-body {
    padding: 15px !important;
  }
  .seller-campaign-cards .campaign-id {
    color: var(--Colors-Primary-500, #d2042d);
    font-size: var(--Font-Font-Size-small, 13px);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .seller-campaign-card-container .total-price {
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h6, 16px);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    font-family: Roboto;
  }
  .date-text-format {
    font-family: Roboto;
    font-size: 14px !important;
    font-weight: 500 !important;
  }
  .badge-col {
    display: flex;
    align-self: flex-end;
    justify-content: center;
    margin-left: 1rem;
  }
  .rfp-badge {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rfp-badge .ant-scroll-number {
    display: flex;
    width: 44px;
    height: 23px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
  .seller-campaign-cards .action-btn {
    padding: 8px;
    border-radius: 5px;
  }
  .seller-campaign-cards .view-btn {
    background: var(--Colors-Primary-500, #d2042d) !important;
    color: #fff !important;
    margin-left: 12px;
    min-width: 120px;
    max-width: 250px;
    width: auto;
    height: 50px;
    border: none;
  }
  .seller-campaign-cards .share-btn {
    background: #f0f0f0 !important;
    color: #0a0f0d !important;
    width: max-content;
    height: 50px;
    min-width: 120px;
    max-width: 250px;
    width: auto;
    border: none;
  }
  .mobile-action-icons {
    width: 1.25rem !important;
  }
  .mobile-share-icon {
    margin-left: 0.5rem;
  }
}

@media (max-width: 375px) {
  .seller-campaign-cards .mobile-card-buttons {
    padding: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/SellerFlow/dashboard/view-campaigns/ViewCampaigns.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;;GAEG;AACH;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;;EAEZ;IACE,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wCAAwC;IACxC,0CAA0C;IAC1C,2CAA2C;IAC3C,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;;EAEtB;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;;IAElB;MACE,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;IAClB;EACF;;EAEA;;IAEE;;MAEE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA,YAAY;;AAEZ;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;AACA,YAAY;AACZ;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yCAAyC;IACzC,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,yDAAyD;IACzD,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF","sourcesContent":["::-webkit-scrollbar {\n  display: none;\n}\n\n.view-seller-campaigns {\n  height: 90vh;\n}\n.scroll-container {\n  max-height: 72vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.view-campaign-container {\n  height: 100%;\n}\n/* .seller-campaign-list {\n  height: 90px;\n} */\n.view-campaigns-header {\n  height: 90px;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.bread-crumb-placement {\n  padding-top: 13px;\n}\n.view-campaigns-header .search-input {\n  margin-left: 1.5rem;\n}\n.ant-image .arrow-align {\n  margin-right: 16px;\n  width: 20px;\n}\n\n.popover-label {\n  font-family: Roboto !important;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.view-campaign-search .ant-input-prefix {\n  margin-right: 1rem;\n}\n\n.view-campaign-search {\n  font-family: Roboto !important;\n  height: 50px;\n\n  .ant-input-group {\n    height: 100%;\n  }\n\n  .ant-input {\n    font-family: Roboto !important;\n    height: 100%;\n  }\n\n  .ant-input-outlined:hover {\n    border: 1px solid #d9d9d9;\n  }\n\n  .ant-input-outlined:focus-within {\n    border: 1px solid #d9d9d9;\n  }\n\n  .ant-input-search-button {\n    height: 100%;\n    border-left: none !important;\n  }\n\n  .ant-input-search-button:not(.ant-btn-primary):active {\n    color: #d9d9d9 !important;\n  }\n\n  .ant-input-search-button:hover {\n    border-top: 1px solid #d9d9d9 !important;\n    border-right: 1px solid #d9d9d9 !important;\n    border-bottom: 1px solid #d9d9d9 !important;\n    border-left: none !important;\n    color: #d9d9d9 !important;\n  }\n}\n\n.view-campaign-search-btn {\n  margin-left: 15.5px;\n}\n\n.seller-campaign-card-container .campaign-details {\n  font-family: \"Roboto\";\n}\n\n.seller-campaign-card-container .campaign-header {\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.view-campaign-segments {\n  margin-top: 22px;\n  vertical-align: middle;\n\n  .ant-segmented-group {\n    align-items: center;\n  }\n\n  .ant-segmented-item {\n    margin-right: 21px;\n\n    .selectedCount {\n      border-radius: 3px;\n      background: #fff;\n      padding: 3px 8px;\n    }\n  }\n\n  .ant-segmented-item,\n  .ant-segmented-item-selected {\n    .ant-segmented-item-label,\n    .ant-segmented-item-label:hover {\n      padding: 8px 20px;\n    }\n\n    .selectedCount {\n      border-radius: 3px;\n      background: #f5f5f5;\n      padding: 3px 8px;\n    }\n  }\n}\n\n.ellipsis-btn {\n  height: 40px;\n  width: 40px;\n  border: none;\n}\n\n.ellipsis-btn:hover,\n.ellipsis-btn:active,\n.ellipsis-btn:focus {\n  background: #f0f0f0 !important;\n}\n\n.popover-content {\n  width: 212px;\n  height: 112px;\n}\n\n.popover-campaign {\n  display: flex;\n  padding: 12px 8px 12px 14px;\n  width: 11vw;\n  margin-left: 0.5rem;\n  height: 43px;\n  border: none;\n  justify-content: center;\n}\n\n.popover-campaign:hover,\n.popover-campaign.active {\n  background: #d2042d !important;\n  color: #fff !important;\n  border-radius: 10px;\n}\n\n.popover-campaign:hover .share-icon {\n  filter: brightness(0) invert(1);\n}\n\n.action-column {\n  display: flex;\n  align-items: center;\n\n  .view-details {\n    margin-right: 38px;\n    margin-left: 8px;\n    margin-bottom: 0;\n    cursor: pointer;\n  }\n}\n\n.view-campaign-ellipsis {\n  transform: rotate(90deg);\n  height: 40px;\n}\n\n.empty-campaigns {\n  display: flex;\n  justify-content: center;\n}\n.view-campaigns-table {\n  width: 94vw;\n  margin-top: 18px;\n  .ant-table-cell {\n    font-family: Roboto;\n    padding: 12px 16px !important;\n  }\n\n  .ant-pagination-options {\n    display: none;\n  }\n}\n\n.payment-term-form {\n  margin: 0.5rem;\n}\n\n.view-campaigns-table .ant-table-thead > tr > th {\n  text-align: left !important;\n}\n\n.custom-row {\n  height: 70px !important;\n}\n\n.share-campaign {\n  width: 100%;\n  margin-top: 1rem;\n  background: #d2042d;\n  color: #fff;\n  padding: 12px;\n}\n\n.rfp-badge-css {\n  font-family: Roboto;\n  /* background: #d2042d; */\n  color: #fff;\n}\n\n.rfp-badge-css sup {\n  background: #d2042d !important;\n}\n.set-width {\n  width: max-content;\n}\n/* Tablet  */\n\n@media (max-width: 1025px) {\n  .view-campaign-segments {\n    width: 90vw !important;\n    overflow-x: scroll;\n  }\n  .view-campaign-table-container {\n    overflow-x: auto;\n    margin-top: 1rem;\n  }\n  .view-campaigns-header .search-input {\n    margin-left: 0;\n  }\n  .view-campaigns-table {\n    background: \"#fff\";\n  }\n  .view-campaigns-table .ant-table-tbody {\n    font-family: Roboto;\n    background: #fff;\n  }\n}\n/* Mobile  */\n@media (max-width: 768px) {\n  .campaign-detail-container-card {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 12px;\n  }\n  .bread-crumb-placement {\n    display: none;\n  }\n  .mobile-view-segmentss-tab {\n    max-width: 500px;\n    min-width: 300px;\n    width: auto;\n    overflow: auto;\n  }\n  .view-campaigns-header {\n    margin-top: 10px;\n    height: 151px;\n    align-items: center;\n  }\n  .scroll-container {\n    padding-right: 0;\n  }\n  .seller-campaign-card-container {\n    gap: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  .seller-campaign-cards .ant-card-body {\n    padding: 15px !important;\n  }\n  .seller-campaign-cards .campaign-id {\n    color: var(--Colors-Primary-500, #d2042d);\n    font-size: var(--Font-Font-Size-small, 13px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .seller-campaign-card-container .total-price {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h6, 16px);\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    font-family: Roboto;\n  }\n  .date-text-format {\n    font-family: Roboto;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n  }\n  .badge-col {\n    display: flex;\n    align-self: flex-end;\n    justify-content: center;\n    margin-left: 1rem;\n  }\n  .rfp-badge {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .rfp-badge .ant-scroll-number {\n    display: flex;\n    width: 44px;\n    height: 23px;\n    padding: 4px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n  .seller-campaign-cards .action-btn {\n    padding: 8px;\n    border-radius: 5px;\n  }\n  .seller-campaign-cards .view-btn {\n    background: var(--Colors-Primary-500, #d2042d) !important;\n    color: #fff !important;\n    margin-left: 12px;\n    min-width: 120px;\n    max-width: 250px;\n    width: auto;\n    height: 50px;\n    border: none;\n  }\n  .seller-campaign-cards .share-btn {\n    background: #f0f0f0 !important;\n    color: #0a0f0d !important;\n    width: max-content;\n    height: 50px;\n    min-width: 120px;\n    max-width: 250px;\n    width: auto;\n    border: none;\n  }\n  .mobile-action-icons {\n    width: 1.25rem !important;\n  }\n  .mobile-share-icon {\n    margin-left: 0.5rem;\n  }\n}\n\n@media (max-width: 375px) {\n  .seller-campaign-cards .mobile-card-buttons {\n    padding: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
